const variantsSelect = document.querySelector('select[data-variants]');
if (variantsSelect) {
  const productVariants = [];
  for (const option of variantsSelect.options) {
    const variantInfo = {
      id: option.value,
      price: option.dataset.price,
      values: option.dataset.values,
      rawPrice: option.dataset.rawPrice,
      compare_at_price: option.dataset.compare_at_price,
      raw_compare_at_price: option.dataset.raw_compare_at_price,
      options: option.dataset.values.split('|'),
      available: option.dataset.hasOwnProperty('available'),
    };
    productVariants.push(variantInfo);
  }

  const productForm = document.querySelector('#add-to-cart');
  const productOptions = document.querySelectorAll('[data-options]');
  const productPrice = document.querySelector("[data-output='price']");
  const productCompareAtPrice = document.querySelector("[data-output='compare_at_price']");
  if (productOptions.length) {
    const convertCurrencyEvent = new CustomEvent('CurrencyConverterUpdate', {
      detail: { outputs: [productPrice, productCompareAtPrice] },
    });
    productOptions.forEach((option) => {
      const isImagesTrigger = option.dataset.hasOwnProperty('variantImagesTrigger');
      const isFamilyTrigger = option.dataset.hasOwnProperty('variantFamilyTrigger');
      const values = option.querySelectorAll('[data-value]');
      values.forEach((value) => {
        value.addEventListener('click', function () {
          if (value.dataset.hasOwnProperty('selected')) return;
          if (isFamilyTrigger) return;
          const current = option.querySelector('[data-selected]');
          current.removeAttribute('data-selected');
          value.dataset.selected = true;
          option.dataset.value = value.dataset.value;
          const selected = updateVariant(productOptions, productVariants);
          toggleForm(productForm, selected ? selected.available : false);
          if (isImagesTrigger)
            filterVariantImages(option.dataset.options.toLowerCase(), option.dataset.value.toLowerCase());
          if (selected) {
            productPrice.dataset.money = selected.rawPrice;
            productCompareAtPrice.dataset.money = selected.raw_compare_at_price;
            document.body.dispatchEvent(convertCurrencyEvent);
          }
        });
      });
      if (isImagesTrigger) {
        window.addEventListener('load', function () {
          filterVariantImages(option.dataset.options.toLowerCase(), option.dataset.value.toLowerCase());
        });
      }
    });
  }
}

function updateVariant(options, variants) {
  const selectedOptions = [];
  options.forEach((option) => {
    selectedOptions.push(option.dataset.value);
  });
  const selectedVariant = variants.find((variant) => variant.values === selectedOptions.join('|'));

  if (!selectedVariant) return false;

  var event = new CustomEvent('OrdersifyFormChange', { detail: { variantID: selectedVariant.id } });
  document.body.dispatchEvent(event);
  const variantInput = document.querySelector("input[name='id']");
  if (variantInput) variantInput.value = selectedVariant.id;
  const variantOutput = document.querySelectorAll('[data-output]');
  variantOutput.forEach((output) => {
    if (output.dataset.output === 'images') {
      const current = output.querySelector('[data-active]');
      if (current) {
        current.classList.replace('db', 'dn');
        current.removeAttribute('data-active');
      }
      const updated = output.querySelector("[data-variant='" + selectedVariant.id + "']");
      if (updated) {
        updated.classList.replace('dn', 'db');
        updated.dataset.active = true;
      }
    } else {
      output.textContent = selectedVariant[output.dataset.output];
    }
  });

  return selectedVariant;
}

function toggleForm(form, isAvailable) {
  const submit = form.querySelector("input[type='submit']");
  const alert = document.querySelector('[data-stock-alert]');

  if (isAvailable) {
    if (form.classList.contains('dn')) form.classList.remove('dn');
    if (submit.disabled) submit.disabled = false;
    if (!alert.classList.contains('dn')) alert.classList.add('dn');
  } else {
    if (!form.classList.contains('dn')) form.classList.add('dn');
    if (!submit.disabled) submit.disabled = true;
    if (alert.classList.contains('dn')) alert.classList.remove('dn');
  }
}

function formatSelectOptionsText(options, current, prepend, append) {
  for (const option of options) {
    if (option.index === current) {
      if (prepend) option.text = prepend + option.text;
      if (append) option.text = option.text + append;
    } else {
      if (prepend) option.text = option.text.replace(prepend, '');
      if (append) option.text = option.text.replace(append, '');
    }
  }
}

function filterVariantImages(option, value) {
  $('[data-variant-images]').slick('slickUnfilter');
  $('[data-variant-images]').slick('slickFilter', `.${option}-${value}, .options-all`);
}

const quantityInput = document.querySelector("div[data-input='quantity']");
if (quantityInput) {
  const productQuantity = document.querySelector("input[name='quantity']");
  initQuantityInput(quantityInput, function (input, value) {
    productQuantity.value = value;
  });
}
